import { useAuth } from 'context/authentication/useAuth'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components/macro'
import { MobileAuthenticatedNav } from 'components/Layout/Navbar/MobileAuthenticatedNav'
import { MobileFooter } from 'components/Layout/Footer/MobileFooter'
import { useSafariViewportFix } from 'hooks/useSafariViewportFix'

export function MobileAppLayout() {
  const { isAuthenticated } = useAuth()

  // Fix Safari's dynamic viewport height issues
  useSafariViewportFix()

  return (
    <LayoutRoot>
      {isAuthenticated && <MobileAuthenticatedNav />}
      <Content id="app-content-container">
        <Outlet />
      </Content>
      {isAuthenticated && <MobileFooter />}
    </LayoutRoot>
  )
}

const LayoutRoot = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh; /* Use dynamic viewport height for Safari support */
  width: 100%;
  overflow: hidden;

  /* Fallback for browsers that don't support dvh */
  @supports not (height: 100dvh) {
    height: calc(var(--vh, 1vh) * 100); /* Use JS-calculated height */
  }
`

const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
`
